<template>
  <div
    ref="root"
    class="navbar-item has-dropdown has-dropdown-with-icons"
    :class="{ 'is-hoverable': isHoverable, 'is-active': isDropdownActive }"
    @click="toggle"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <a class="navbar-link is-arrowless">
      <slot />
      <b-icon
        :icon="dropdownIcon"
        custom-size="default"
      />
    </a>
    <slot name="dropdown" />
  </div>
</template>

<script>
import { defineComponent, nextTick, onMounted, onUnmounted } from 'vue'

export default defineComponent({
  name: 'NavBarMenu',
  props: {
    isHoverable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isDropdownActive: false
    }
  },
  computed: {
    dropdownIcon () {
      return this.isDropdownActive ? 'chevron-up' : 'chevron-down'
    }
  },
  mounted () {
    window.addEventListener('click', this.forceClose)
    window.addEventListener('resize', this.setDropdownPosition)
  },
  beforeDestroy () {
    window.removeEventListener('click', this.forceClose)
    window.removeEventListener('resize', this.setDropdownPosition)
  },
  methods: {
    toggle () {
      if (!this.isHoverable) {
        this.isDropdownActive = !this.isDropdownActive
        if (this.isDropdownActive) {
          this.setDropdownPosition()
        }
      }
    },
    handleMouseEnter () {
      if (this.isHoverable) {
        this.isDropdownActive = true
        this.setDropdownPosition()
      }
    },
    handleMouseLeave () {
      if (this.isHoverable) {
        this.isDropdownActive = false
      }
    },
    forceClose (e) {
      if (!this.$refs.root.contains(e.target)) {
        this.isDropdownActive = false
      }
    },
    setDropdownPosition () {
      nextTick(() => {
        const rootEl = this.$refs.root
        const dropdown = rootEl.querySelector('.navbar-dropdown')
        if (dropdown) {
          const rect = rootEl.getBoundingClientRect()
          dropdown.style.position = 'fixed'
          dropdown.style.top = `${rect.bottom}px`
          dropdown.style.left = `${rect.left}px`
          dropdown.style.zIndex = '1001'
          
          // 处理三级菜单的定位
          const subDropdowns = dropdown.querySelectorAll('.navbar-dropdown')
          subDropdowns.forEach(subDropdown => {
            const parentItem = subDropdown.parentElement
            if (parentItem) {
              // 为二级菜单项添加鼠标悬停事件，用于重新计算三级菜单位置
              parentItem.addEventListener('mouseenter', () => {
                const parentRect = parentItem.getBoundingClientRect()
                subDropdown.style.position = 'fixed'
                subDropdown.style.top = `${parentRect.top}px`
                subDropdown.style.left = `${parentRect.right}px`
                subDropdown.style.zIndex = '1002'
              })
            }
          })
        }
      })
    }

  }
})
</script>
